export type RecipientIdKind = 'south_african_id' | 'passport' | 'invalid' | 'empty';

export interface RecipientIdentityValidation {
  isValid: boolean;
  type: RecipientIdKind;
  ottIdType: 'RSAID' | 'PASSPT' | null;
  reason?: string;
}

function luhn13(digits: string): boolean {
  if (!/^\d{13}$/.test(digits)) return false;
  let sum = 0;
  let alt = false;
  for (let i = digits.length - 1; i >= 0; i -= 1) {
    let d = parseInt(digits[i], 10);
    if (alt) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    alt = !alt;
  }
  return sum % 10 === 0;
}

export function isPlaceholderRecipientId(value: string): boolean {
  const normalized = String(value || '').replace(/\s/g, '');
  return /^0+$/.test(normalized);
}

export function validateRecipientIdentity(value: string): RecipientIdentityValidation {
  const v = String(value || '').replace(/\s/g, '');
  if (!v) return { isValid: false, type: 'empty', ottIdType: null, reason: 'Required' };
  if (isPlaceholderRecipientId(v)) {
    return { isValid: false, type: 'invalid', ottIdType: null, reason: 'Enter the account holder\'s real ID or passport' };
  }
  if (/^\d{13}$/.test(v)) {
    return luhn13(v)
      ? { isValid: true, type: 'south_african_id', ottIdType: 'RSAID' }
      : { isValid: false, type: 'south_african_id', ottIdType: null, reason: 'SA ID must pass checksum' };
  }
  if (/^[A-Z0-9]{6,9}$/i.test(v)) {
    return { isValid: true, type: 'passport', ottIdType: 'PASSPT' };
  }
  return { isValid: false, type: 'invalid', ottIdType: null, reason: 'Enter a 13-digit SA ID or a 6–9 character passport' };
}
